var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("headbox", { attrs: { title: "卖金", bgColor: "#FEAE14" } }),
      _c(
        "div",
        { staticClass: "rel" },
        [
          _c("div", { staticClass: "yellowbox" }),
          _c("center", { staticClass: "boxgoldprice" }, [
            _c("h2", [_vm._v("实时价格(元/克)")]),
            _c("div", { staticClass: "pricebox" }, [
              _vm._v(_vm._s(_vm.pricebox))
            ])
          ]),
          _c(
            "div",
            { staticClass: "bottombox" },
            [
              !_vm.loadingtrue
                ? _c(
                    "div",
                    [
                      _c(
                        "center",
                        { staticClass: "centerboxloading" },
                        [_c("van-loading", { attrs: { size: "50" } })],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.loadingtrue
                ? _c("div", { staticClass: "userselect" }, [
                    _c("div", { staticClass: "title_box rel" }, [
                      _vm._v("选择类别 "),
                      _c(
                        "i",
                        {
                          staticClass: "tipboxcarid",
                          on: { click: _vm.showTip }
                        },
                        [_vm._v("?")]
                      ),
                      _vm.tipcenter
                        ? _c("div", { staticClass: "tipboxback" }, [
                            _vm._v("黄金各品类按照黄金9999定价即可")
                          ])
                        : _vm._e()
                    ]),
                    _c(
                      "div",
                      {
                        class: _vm.issslect ? "citybox drepcolor" : " citybox",
                        on: { click: _vm.showPopup }
                      },
                      [_vm._v(_vm._s(_vm.initCity))]
                    ),
                    _c("div", { staticClass: "title_box" }, [
                      _vm._v("卖出克重")
                    ]),
                    _c("div", { staticClass: "weightbox flex-between" }, [
                      _c(
                        "div",
                        [
                          _c("el-input", {
                            class: _vm.isinput ? "yellowfont" : "",
                            attrs: {
                              placeholder: "请输入克重",
                              type: "tel",
                              maxlength: "6"
                            },
                            on: { input: _vm.handleInput2 },
                            model: {
                              value: _vm.weight,
                              callback: function($$v) {
                                _vm.weight = $$v
                              },
                              expression: "weight"
                            }
                          })
                        ],
                        1
                      ),
                      _c("div", { staticClass: "unit" }, [_vm._v("克")])
                    ]),
                    _c("div", { staticClass: "title_box" }, [
                      _vm._v("预估金额")
                    ]),
                    _c("span", { staticClass: "moneybox flex-between " }, [
                      _c(
                        "div",
                        {
                          staticClass: "countMumber",
                          class: _vm.isinput ? "yellowfont" : ""
                        },
                        [_vm._v(_vm._s(_vm.countMumber))]
                      ),
                      _c("div", [_vm._v("元")])
                    ])
                  ])
                : _vm._e(),
              _c(
                "div",
                {
                  staticClass: "btnbox",
                  on: {
                    click: function($event) {
                      return _vm.postData("showpop")
                    }
                  }
                },
                [_vm._v("立即定价")]
              ),
              _vm._m(0),
              _c(
                "div",
                [
                  _c(
                    "van-popup",
                    {
                      attrs: { position: "bottom" },
                      model: {
                        value: _vm.show,
                        callback: function($$v) {
                          _vm.show = $$v
                        },
                        expression: "show"
                      }
                    },
                    [
                      _c("van-area", {
                        attrs: {
                          "area-list": _vm.areaList,
                          "cancel-button-text": " "
                        },
                        on: { confirm: _vm.confirmF }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "van-dialog",
                {
                  model: {
                    value: _vm.tipsell,
                    callback: function($$v) {
                      _vm.tipsell = $$v
                    },
                    expression: "tipsell"
                  }
                },
                [
                  _c("div", { staticClass: "title" }, [_vm._v("卖金须知")]),
                  _c("div", { staticClass: "centerbox_dialog _leftbox" }, [
                    _c("p", [
                      _vm._v(
                        "1、我司仅支持实物贵金属回收，黄金各品类定价选择黄金9999即可，中鑫金收到货物后将根据黄金9999的折足克重为您结算。"
                      )
                    ]),
                    _c("p", [
                      _vm._v(
                        "2、您的定价审核通过后请在72小时内将货物寄出，只定价不发货属于违约行为，我方有权追究法律责任，请谨慎定价。"
                      )
                    ])
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "gocer",
                      on: {
                        click: function($event) {
                          _vm.tipsell = false
                        }
                      }
                    },
                    [_vm._v("确定")]
                  )
                ]
              ),
              _c(
                "van-dialog",
                {
                  model: {
                    value: _vm.showorder,
                    callback: function($$v) {
                      _vm.showorder = $$v
                    },
                    expression: "showorder"
                  }
                },
                [
                  _c("div", { staticClass: "title" }, [_vm._v("订单确认")]),
                  _c("div", { staticClass: "centerbox_dialog" }, [
                    _c("p", [_vm._v("交易类别：" + _vm._s(_vm.initCity))]),
                    _c("p", [
                      _vm._v("实时价格：" + _vm._s(_vm.pricebox) + "元")
                    ]),
                    _c("p", [_vm._v("交易克重：" + _vm._s(_vm.weight) + "克")]),
                    _c("p", [
                      _vm._v("订单金额：" + _vm._s(_vm.countMumber) + "元")
                    ])
                  ]),
                  _c("div", { staticClass: "flex popbtn" }, [
                    _c(
                      "div",
                      {
                        staticClass: "gocer closebtn",
                        on: { click: _vm.closepop }
                      },
                      [_vm._v("取消")]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "gocer",
                        on: {
                          click: function($event) {
                            return _vm.postData("postDataf")
                          }
                        }
                      },
                      [_vm._v("确定")]
                    )
                  ])
                ]
              ),
              _c(
                "van-dialog",
                {
                  model: {
                    value: _vm.ceringModel,
                    callback: function($$v) {
                      _vm.ceringModel = $$v
                    },
                    expression: "ceringModel"
                  }
                },
                [
                  _c("div", { staticClass: "title" }, [_vm._v("提示")]),
                  _c("div", { staticClass: "centerbox_dialog" }, [
                    _vm._v(
                      "停盘中，暂时无法进行交易，开盘时间周一至周五10:00-23:00"
                    )
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "gocer",
                      on: {
                        click: function($event) {
                          _vm.ceringModel = false
                        }
                      }
                    },
                    [_vm._v("确定")]
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tipBox" }, [
      _c("div", [_vm._v("温馨提示")]),
      _c("div", [
        _vm._v(
          "1、定价时间：周一至周五10:00-23:30，周六为11:00-23:30，周日不支持定价。"
        )
      ]),
      _c("div", [
        _vm._v(
          "2、定价品类：黄金各品类按照黄金9999定价并填写预估克重即可，中鑫金收到货物后将为您返回准确折足重量供您确认。"
        )
      ]),
      _c("div", [
        _vm._v(
          "3、交付方式：定价审核通过后，请在72小时内面付或者顺丰发货将货物送至中鑫金，定价不发货属于违约行为，我司将追究法律责任，请您谨慎定价。"
        )
      ]),
      _c("div", [
        _vm._v(
          "4、关于结算：中鑫金收货后将严格按照国标进行精密检测，并返回详细结算单供用户确认，确认无误后进行打款"
        )
      ]),
      _c("div", [
        _vm._v(
          "5、如有任何疑问，请拨打客服电话4001-886-722,中鑫金将竭诚为您服务。"
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }